import React, { useRef } from 'react';
import { motion, useMotionTemplate, useMotionValue } from 'framer-motion';

/**
 * Card wrapper with a soft radial highlight that follows the pointer.
 */
export default function Spotlight({ children, className = '', color = 'rgba(240, 85, 44, 0.16)', style, ...rest }) {
  const ref = useRef(null);
  const mx = useMotionValue(-400);
  const my = useMotionValue(-400);

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    mx.set(e.clientX - r.left);
    my.set(e.clientY - r.top);
  };

  const onLeave = () => {
    mx.set(-400);
    my.set(-400);
  };

  const background = useMotionTemplate`radial-gradient(420px circle at ${mx}px ${my}px, ${color}, transparent 65%)`;

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={`spotlight ${className}`}
      style={{ position: 'relative', overflow: 'hidden', ...style }}
      {...rest}
    >
      <motion.div
        aria-hidden
        style={{ position: 'absolute', inset: 0, background, pointerEvents: 'none', zIndex: 0 }}
      />
      <div style={{ position: 'relative', zIndex: 1, height: '100%' }}>{children}</div>
    </motion.div>
  );
}
